import Vue from "vue";
// import { da } from "date-fns/esm/locale";

function initialState() {
  return {
    AllUsers: [],
    UserList: [],
    AAUsers: [],
    DepartmentList: [],
    SupervisorList: [],
    Pagination: 0,
    CurrentPage: 0,
    CurrentSize: 25,
    TotalUsers: 0,
    ShowDeactivationModal: false,
    ShowActivationModal: false,
    AddUserModal: {
      ShowModal: false
    },
    ShowUserLockdownModal: false,
    UserSupervisorExists: false,
    UserCustomSignatureModalInfo : {
      showModal : false,
      data : null
    },
    UserIntegrationIDModalInfo: {
      showModal: false,
      data: null
    }
  };
}

const state = initialState();

const getters = {
  AllUsers: function () {
    return state.AllUsers;
  },
  UserList: function () {
    return state.UserList;
  },
  // UsersLoading: function () {
  //   return state.UsersLoading;
  // },
  DepartmentList: function () {
    return state.DepartmentList;
  },
  SupervisorList: function () {
    return state.SupervisorList;
  },
  SizeList: function () {
    return state.SizeList;
  },
  CurrentPage: function () {
    return state.CurrentPage;
  },
  TotalUsers: function () {
    return state.TotalUsers;
  },
  CurrentSize: function () {
    return state.CurrentSize;
  },
  ShowDeactivationModal: function (state) {
    return state.ShowDeactivationModal;
  },
  ShowActivationModal: function (state) {
    return state.ShowActivationModal;
  },
  AddUserModal: function (state) {
    return state.AddUserModal;
  },
  ShowUserLockdownModal: function (state) {
    return state.ShowUserLockdownModal;
  },
  UserSupervisorExists: function (state) {
    return state.UserSupervisorExists;
  },
  AAUsers: function (state) {
    return state.AAUsers;
  }
};

const actions = {
  async getDealershipUsers(context) {
    let allUsers = [];
    const pageSize = 500;

    const firstPageData = await context.dispatch("getDealershipUsersByPage", {
      page: 0,
      size: pageSize
    });

    if ((firstPageData || []).length > 0) {
      allUsers = firstPageData;
      const pageCount = Math.ceil(firstPageData[0].MatchedCount / pageSize);

      if (pageCount > 1) {
        const pages = [...Array(pageCount).keys()];
        let pageCalls = [];

        for (let page of pages) {
          if (page == 0) continue;

          pageCalls.push(context.dispatch("getDealershipUsersByPage", {
            page: page,
            size: pageSize
          }));
        }

        const pageResponses = await Promise.all(pageCalls);

        for (let pageResponse of pageResponses) {
          if ((pageResponse || []).length == 0) continue;
          allUsers = allUsers.concat(pageResponse);
        }
      }
    }

    allUsers.sort((usr1, usr2) => {
      if (usr1.Active == usr2.Active) return (usr1.Name || "").toLowerCase() > (usr2.Name || "").toLowerCase() ? 1 : -1;
      else return usr1.Active ? -1 : 1;
    });

    context.commit("UpdateAllUserList", allUsers);
    context.commit("UpdateSupervisorList", allUsers);
  },
  async getDealershipUsersByPage(context, request) {
    try {
      const pagedQuery = `from=${request.page * request.size}&size=${request.size}&orderBy=LastName&orderDir=asc&returnAllAccountUsers=true`;

      const response = await Vue.http.get(`/core/users?${pagedQuery}`).catch(err => err.response);
      if (!response || !response.data || !response.data.Data) {
        console.log("No users found for query: ", pagedQuery);
        return [];
      } else return response.data.Data;
    } catch (err) {
      console.log("Error loading users for request: ", request);
    }
  },
  // getAllUsersForAccount: function (context, data) {
  //   return new Promise((resolve, reject) => {
  //     if (context.getters.AllUsers && context.getters.AllUsers.length > 0) {
  //       resolve(context.getters.AllUsers);
  //       return;
  //     }

  //     Vue.http
  //       .get("/core/users?returnAllAccountUsers=true")
  //       .then(function (data) {
  //         context.commit("UpdateAllUserList", data.data.Data);
  //         context.commit("UpdateSupervisorList", data.data.Data);
  //         resolve(data.data.Data);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // },
  // getCoreUsersForAccount: function (context) {
  //   return new Promise((resolve, reject) => {
  //     Vue.http
  //       .get("/core/users?returnAllAccountUsers=true")
  //       .then(function (data) {
  //         if (data && data.data && data.data.Data) resolve(data.data.Data);
  //         else reject(data);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // },
  getAutoAlertUsers: function (context) {
    let request = {
      AccountId: 1,
      ActiveOnly: false
    };
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/users/filter", request)
        .then(function (response) {
          if (response && response.data.Data) {
            context.commit("updateAAUsers", response.data.Data);
          }
          resolve(response.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUsersByFilter: function (context, query) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("core/users" + query)
        .then(function (data) {
          context.commit("UpdateUserList", data.data.Data);
          if (data && data.data.Data.length > 0)
            context.commit("UpdateUsersCount", data.data.Data[0].MatchedCount);
          else context.commit("UpdateUsersCount", 1);

          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUsersByFilterForCSV: function (context, query) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("core/users/exportUserListToCSV" + query)
        .then(function (response) {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadDepartments: function (context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("core/groups/org")
        .then(function (data) {
          context.commit("UpdateDepartmentList", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadAllDepartments: function (context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/core/groups/filtergroup", request)
        .then(resp => {
          resolve(resp && resp.data ? resp.data.Data : []);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  saveUserRecord: function (context, user) {
    if (user == null) reject("error");
    return new Promise((resolve, reject) => {
      Vue.http
        .put("core/users/" + user.Id, user)
        .then(function (data) {
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  toggleDeactivationModal: function (context, show) {
    context.commit("toggleDeactivationModal", show);
  },
  toggleActivationModal: function (context, show) {
    context.commit("toggleActivationModal", show);
  },
  updateUserStatus: function (context, userinfo) {
    if (!userinfo.Id) return "Invalid/No userId";

    if (userinfo.Status) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("/core/users/" + userinfo.Id + "/deactivate")
          .then(resp => {
            resolve(resp);
          })
          .catch(resp => {
            reject(resp);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("/core/users/" + userinfo.Id + "/approve")
          .then(resp => {
            resolve(resp);
          })
          .catch(resp => {
            reject(resp);
          });
      });
    }
  },
  updateEditedUser: function (context, user) {
    context.commit("updateEditedUser", user);
  },
  openAddUserModal: function (context) {
    context.commit("openAddUserModal");
  },
  closeAddUserModal: function (context) {
    context.commit("closeAddUserModal");
  },
  registerUser: async function (context, data) {
    return await Vue.http.post("/account/selfregister", data).catch(err => err.response);
  },
  UpdateCurrentSize: function (context, size) {
    context.commit("updateCurrentSize", size);
  },
  UpdateCurrentPage: function (context, page) {
    context.commit("updateCurrentPage", page);
  },
  ToggleUserLockdownModal: function (context, status) {
    context.commit("ToggleUserLockdownModal", status);
  },
  LockUser: function (context, user) {
    return new Promise((resolve, reject) => {
      Vue.http
        .put("/core/users/" + user.Id + "/lock")
        .then(resp => {
          if (resp && resp.data && resp.data.Success) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  UnLockUser: function (context, user) {
    return new Promise((resolve, reject) => {
      Vue.http
        .put("/core/users/" + user.Id + "/unlock")
        .then(resp => {
          if (resp && resp.data && resp.data.Success) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  UserSupervisorExists: function (context, userId) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/userdeactivation/usersupervisorexists?userId=" + userId)
        .then(function (data) {
          context.commit("updateUserSupervisorExists", data.data.Data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCustomSignatureModalInfo(context, data){
      context.commit("updateCustomSignatureModalInfo", data); 
  },
  updateIntegrationIDModalInfo(context, data) {
    context.commit("updateIntegrationIDModalInfo", data);
  },
  async getUserSignatureSettings(context, userId){
    let response = await Vue.http
    .get(`/users/${userId}/custom_signature`).catch(err => err.response);
    return response && response.data ? response.data.Data : null;
  },
  async saveUserSignatureSettings(context, data){
    let response = await Vue.http
    .post(`/users/custom_signature`, data).catch(err => err.response);
    return response && response.data ? response.data.Data : null;
  }
};

const mutations = {
  UpdateAllUserList: function (state, data) {
    state.AllUsers = data;
  },
  UpdateUserList: function (state, data) {
    let updatedList = [];
    if (data && data.length > 0) {
      for (var user of data) {
        user.SelectedDepartment = null;

        if (user.SupervisorId && user.SupervisorId.length > 0) {
          user.SelectedSupervisor = {
            SupervisorId: user.SupervisorId,
            SupervisorName: user.SupervisorName
          };
        } else {
          user.SelectedSupervisor = null;
        }

        updatedList.push(user);
      }
    }
    state.UserList = updatedList;
  },
  // UpdateLoadingIcon: function (state, data) {
  //   state.UsersLoading = data;
  // },
  UpdateDepartmentList: function (state, data) {
    state.DepartmentList = data;
  },
  UpdateSupervisorList: function (state, data) {
    let supervisorlist = [];

    if (data && data.length > 0) {
      for (var user of data) {
        supervisorlist.push({
          SupervisorId: user.Id,
          SupervisorName: user.Name
        });
      }
    }
    state.SupervisorList = supervisorlist;
  },
  updateCurrentPage: function (state, data) {
    state.CurrentPage = data;
  },
  UpdateUsersCount: function (state, data) {
    let currentsize = state.CurrentSize;
    let count = data / currentsize;
    state.TotalUsers = Math.ceil(count);
  },
  toggleDeactivationModal: function (state, show) {
    state.ShowDeactivationModal = show;
  },
  toggleActivationModal: function (state, show) {
    state.ShowActivationModal = show;
  },
  updateEditedUser: function (state, user) {
    if (user && user.Id && state.UserList && state.UserList.length > 0) {
      if (user.OrgGroupId && user.OrgGroupId.length > 0) {
        let item = {
          Id: user.OrgGroupId,
          GroupName: user.OrgGroupName,
          AccountPlatformId: user.AccountPlatformID,
          Platform: user.Platform
        };
        user.SelectedDepartment = item;
      } else {
        user.SelectedDepartment = null;
      }
    }

    if (user.SupervisorId && user.SupervisorId.length > 0) {
      user.SelectedSupervisor = {
        SupervisorId: user.SupervisorId,
        SupervisorName: user.SupervisorName
      };
    } else {
      user.SelectedSupervisor = null;
    }

    let prevUserIndex = state.UserList.findIndex(usr => usr.Id == user.Id);
    if (prevUserIndex >= 0) {
      let prevUser = state.UserList[prevUserIndex];
      if (user.UserStatus == prevUser.UserStatus)
        state.UserList.splice(prevUserIndex, 1, user);
      else state.UserList.splice(prevUserIndex, 1);
    }
  },
  openAddUserModal(state) {
    state.AddUserModal.ShowModal = true;
  },
  closeAddUserModal(state) {
    state.AddUserModal.ShowModal = false;
  },
  updateCurrentSize: function (state, size) {
    state.CurrentSize = size;
  },
  ToggleUserLockdownModal: function (context, status) {
    state.ShowUserLockdownModal = status;
  },
  updateUserSupervisorExists: function (state, isValid) {
    state.UserSupervisorExists = isValid;
  },
  updateAAUsers: function (state, data) {
    state.AAUsers = data;
  },
  updateCustomSignatureModalInfo(state, data){
    state.UserCustomSignatureModalInfo = data;
  },
  updateIntegrationIDModalInfo(state, data) {
    state.UserIntegrationIDModalInfo = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/users/UserList.js